<article class="payment-row">
    <div class="payment-cell">
        <span class="payment-label">{{ 'financials.revenueList.date' | translate }}</span>
        <span class="payment-value">{{ payment!.createdAt | translocoDate: { dateStyle: 'medium'} }}</span>
    </div>

    <div class="payment-cell">
        <span class="payment-label">{{ 'financials.revenueList.course' | translate }}</span>
        <span class="payment-value payment-course">{{ getProductName(payment) }}</span>
    </div>

    <div class="payment-cell">
        <span class="payment-label">{{ 'financials.revenueList.user' | translate }}</span>
        <span class="payment-value">{{ payment?.userName }}</span>
    </div>

    <div class="payment-cell">
        <span class="payment-label">{{ 'financials.revenueList.status' | translate }}</span>
        <span class="payment-status-pill" [ngClass]="getStatusClass(payment!.paymentStatus)">
            {{ getPaymentText(payment!.paymentStatus) | translate }}
        </span>
    </div>

    <div class="payment-cell payment-cell-amount">
        <span class="payment-label">{{ 'financials.revenueList.amount' | translate }}</span>
        <span class="payment-value payment-amount">{{ payment!.amount | translocoCurrency: 'symbol' : { minimumFractionDigits: 2 }: payment!.currency }}</span>
    </div>
</article>
